import fetch from "./fetch";
/**
 * 敏感词汇
 */
const sensitive = {
  //分页
  getSensitiveWords(params) {
    return fetch({
      isLoading: true,
      url: "/filterWord/page",
      method: "GET",
      params,
    });
  },
  //移除
  removeSensitiveWords(data) {
    return fetch({
      isLoading: true,
      url: "/filterWord/remove",
      method: "POST",
      data,
    });
  },
  //新增
  addSensitiveWords(params) {
    return fetch({
      isLoading: true,
      url: "/filterWord/save",
      method: "GET",
      params,
    });
  },
};

export default sensitive;
